import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import DashboardHome from '../pages/dashboard/DashboardHome.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'
import identityManager from '../managers/identity/IdentityManager'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: DashboardHome,
      },
      {
        name: 'enrollment',
        path: 'enrollment',
        children: [
          {
            name: 'enrollment-embarcaciones',
            path: 'embarcaciones',
            component: () => import('../pages/enrolamiento_2/embarcaciones/EnrollmentEmbarcacionesPage.vue'),
          },
          {
            name: 'enrollment-armadores',
            path: 'armadores',
            component: () => import('../pages/enrolamiento_2/armadores/EnrollmentArmadoresPage.vue'),
          },
          {
            name: 'enrollment-tripulantes',
            path: 'tripulantes',
            component: () => import('../pages/enrolamiento_2/tripulantes/EnrollmentTripulantesPage.vue'),
          },
          {
            name: 'enrollment-proveedores',
            path: 'proveedores',
            component: () => import('../pages/enrolamiento_2/proveedores/EnrollmentProveedoresPage.vue'),
          },
        ],
      },
      {
        name: 'enrollment-check',
        path: 'enrollment-check',
        children: [
          {
            name: 'enrollment-embarcaciones-check',
            path: 'embarcaciones',
            component: () => import('../pages/estatus-enrolamiento/embarcaciones/EnrollmentCheckEmbarcacionesPage.vue'),
          },
          {
            name: 'enrollment-armadores-check',
            path: 'armadores',
            component: () => import('../pages/estatus-enrolamiento/armadores/EnrollmentCheckArmadoresPage.vue'),
          },
          {
            name: 'enrollment-tripulantes-check',
            path: 'tripulantes',
            component: () => import('../pages/estatus-enrolamiento/tripulantes/EnrollmentCheckTripulantesPage.vue'),
          },
          {
            name: 'enrollment-proveedores-check',
            path: 'proveedores',
            component: () => import('../pages/estatus-enrolamiento/proveedores/EnrollmentCheckProveedoresPage.vue'),
          },
          {
            name: 'enrollment-representantes-check',
            path: 'representantes',
            component: () =>
              import('../pages/estatus-enrolamiento/representantes/EnrollmentCheckRepresentantesPage.vue'),
          },
          {
            name: 'enrollment-esporadicos-check',
            path: 'esporadicos',
            component: () => import('../pages/enrolamiento_2/esporadicos/EnrollmentCheckEsporadicosPage.vue'),
          },
        ],
      },
      {
        name: 'administracion',
        path: 'administracion',
        children: [
          {
            name: 'administration-users',
            path: 'administracion-usuarios',
            component: () => import('../pages/administracion/usuarios/AdministracionUsuariosPage.vue'),
          },
          {
            name: 'administration-tarifas',
            path: 'administracion-tarifas',
            component: () => import('../pages/administracion/tarifas/AdministracionTarifasPage.vue'),
          },
          {
            name: 'administration-horarios',
            path: 'administracion-horarios',
            component: () => import('../pages/administracion/horarios/AdministracionHorariosPage.vue'),
          },
          {
            name: 'administration-roles-alternativos',
            path: 'administracion-roles-alternativos',
            component: () =>
              import('../pages/administracion/roles-alternativos/AdministracionRolesAlternativosPage.vue'),
          },
          {
            name: 'administration-configuracion-credenciales',
            path: 'administracion-configuracion-credenciales',
            component: () =>
              import(
                '../pages/administracion/configuracion-credenciales/AdministracionConfiguracionCredencialesPage.vue'
              ),
          },
          {
            name: 'administration-configuracion',
            path: 'administracion-configuracion',
            component: () =>
              import('../pages/administracion/configuracion/AdministracionConfiguracionPage.vue'),
          },
          {
            name: 'administration-otros',
            path: 'administracion-otros',
            component: () => import('../pages/administracion/otros/AdministracionOtrosPage.vue'),
          },
        ],
      },
      {
        name: 'solicitudes',
        path: 'solicitudes',
        component: () => import('../pages/solicitudes/SolicitudesPage.vue'),
      },
      {
        name: 'services',
        path: 'services',
        alias: '/servicios',
        component: () => import('../pages/servicios/ServiciosPage.vue'),
      },
      {
        name: 'preacreditacion',
        path: 'preacreditacion',
        component: () => import('../pages/preacreditacion/PreacreditacionPage.vue'),
      },
      {
        name: 'services-request',
        path: 'services-request',
        alias: '/solicitud-servicios',
        component: () => import('../pages/solicitud-servicios/ServiciosPage.vue'),
      },
      {
        name: 'solicitud-servicios',
        path: 'solicitud-servicios',
        component: () => import('../pages/solicitud-servicios/ServiciosPage.vue'),
      },
      {
        name: 'reportes',
        path: 'reportes',
        component: () => import('../pages/reportes/ReportesPage.vue'),
      },
      {
        name: 'reportes-armador',
        path: 'reportes-armador',
        component: () => import('../pages/reportes-armador/ReportesArmadorPage.vue'),
      },
      {
        name: 'control',
        path: 'control',
        component: () => import('../pages/controlmp/ControlMPPage.vue'),
      },
      {
        name: 'finanzas-check',
        path: 'finanzas-check',
        component: () => import('../pages/finanzas-check/FinanzasCheckPage.vue'),
      },
      {
        name: 'auditoria',
        path: 'auditoria',
        component: () => import('../pages/auditoria/AuditoriaPage.vue'),
      },
      {
        name: 'marcas',
        path: 'marcas',
        component: () => import('../pages/marcas/MarcasPage.vue'),
      },
      {
        name: 'viajes',
        path: 'viajes',
        component: () => import('../pages/solicitud-servicios/BandejaRevisionAOZPage.vue'),
      },
      {
        name: 'viajes-backup',
        path: 'viajes-backup',
        component: () => import('../pages/viajes/ViajesPageBackup.vue'),
      },
      {
        name: 'autorizacion-zarpe',
        path: 'autorizacion-zarpe',
        component: () => import('../pages/solicitud-servicios/BandejaRevisionAOZPage.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'mis-representantes',
        path: 'mis-representantes',
        component: () => import('../pages/enrolamiento_2/representantes/MisRepresentantesPage.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        component: RouteViewComponent,
        children: [
          {
            name: 'payment-methods',
            path: 'payment-methods',
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
      {
        name: 'faq',
        path: '/faq',
        component: () => import('../pages/faq/FaqPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        // Selector de contraseña por token (observación #8). Público: el apoderado/usuario
        // nuevo abre el enlace sin sesión. El token viaja como query param ?token=…
        name: 'set-password',
        path: 'set-password',
        component: () => import('../pages/auth/SetPassword.vue'),
      },
      {
        name: 'force-password-change',
        path: 'force-password-change',
        component: () => import('../pages/auth/PasswordChangeForcedPage.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: 'verificar-ao',
    path: '/verificar-ao',
    component: () => import('../pages/public/VerificarAOPage.vue'),
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to, _from, next) => {
  const requiresChange = identityManager.getRequiresPasswordChange().value
  if (requiresChange && to.name !== 'force-password-change' && to.name !== 'login') {
    next({ name: 'force-password-change' })
    return
  }
  if (!requiresChange && to.name === 'force-password-change') {
    next({ name: 'dashboard' })
    return
  }
  next()
})

router.onError((error, to) => {
  if (
    /Failed to fetch dynamically imported module/i.test(error?.message || '') ||
    /Importing a module script failed/i.test(error?.message || '')
  ) {
    console.warn('[Router] Error cargando chunk dinámico (despliegue nuevo o caché obsoleta), recargando...', error)
    if (to?.fullPath) {
      window.location.href = to.fullPath
    } else {
      window.location.reload()
    }
  }
})

export default router
